// coming in es6, make a module or npm import one
if (!String.prototype.trim) {
    (function() {
        // Make sure we trim BOM and NBSP
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        String.prototype.trim = function() {
            return this.replace(rtrim, '');
        };
    })();
}

var assert = {
    hasValue(input) {
        return input.trim() !== '';
    },
    minLength(minLength) {
        return function(input) {
            if(typeof input === 'number') {
                throw new Error("min length is for strings only. Try Assert.greaterThan()")
            }

            return input.trim().length >= minLength;
        };
    },
    isInteger(input) {
        return typeof input === "number" && Math.floor(input) === input;
    },
    isNumber(input) {
        // parseFloat can't be used in validation because parseFloat('2thanksbrendan') === 2;
        if(typeof input === 'string') {
            // check if it is an empty string because isNaN('') is false
            if(input.trim() == '') {
                return false;
            }

            if(isNaN(input)) {
                return false;
            }

            return isFinite(input);
        }

        return ! Number.isNaN(input) && Number.isFinite(input);
    },
    lessThan(maximummNumber) {
        return function(input) {
            return input < maximummNumber;
        }
    },
    greaterThan(minimumNumber) {
        return function(input) {
            return input > minimumNumber;
        }
    },
    gte(minimumNumber) {
        return function(input) {
            return input >= minimumNumber;
        }
    },
    isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    },
    isArrayOfValues(input) {
        return Object.prototype.toString.call(input) === '[object Array]' && input.filter(i => !! i).length;
    },
    isSame(inputKey) {
        return function (input, inputs) {
            var inputToCompare = inputs[inputKey].value;
            return input == inputToCompare;
        }
    },
    isMomentObject(input) {
        return input._isAMomentObject;
    }
};

export default assert;


// WEBPACK FOOTER //
// ./app/assert/Assert.js